export const ROLE_CASHIER = 1;
export const ROLE_ADMIN = 2;
export const ROLE_SUPERADMIN = 3;

const overridesMap = {
  [ROLE_CASHIER]: 'users',
  [ROLE_ADMIN]: 'cashiers',
  [ROLE_SUPERADMIN]: 'admins',
};

export function getLocalizedByRole(role) {
  return overridesMap[role];
}
